export class Payment {
  intakeId: number
  userId: number
  planId: number
  lineOfBusiness: string
  billingZipCode: string
  ccNumber: string
  ccv2Code: string
  ccExpirationYear: string
  ccExpirationMonth: string
}